import _url from '../utils/url';

const url = _url.parse(window.location.href);


// 缓存所有error
let errorLogs = [];

window.nativeErrorLogs = errorLogs;

export function logError(err) {
  errorLogs.push(err);
}

/**
 * 检测是否支持原生接口
 * 检测某原生接口是否存在
 *
 * @export
 * @param {any} api 完整的api名称；如果为空，则检测是否支持原生接口
 */
export function supportNative(api) {

  return !!window.zzc && url.hostname !== 't-dev.tantu.local';

  // let result = !!(zzc && zzcjsbridge);

  // if (result && api) {
  //   return !!zzc[api];
  // } else {
  //   return result;
  // }
}



export function getErrorFactory(api) {
  return function (message) {
    return new NativeError(message, api);
  };
}

export class NativeError extends Error {
  constructor(message, apiName = '') {
    message = `${apiName}: ${message}`;
    super(message);

    this.api = apiName;
    this.name = 'NativeError';
  }
}



// WEBPACK FOOTER //
// ./src/native/util.js